<template>
  <div>
    <nx-relation-editor-toolbar :title="label"></nx-relation-editor-toolbar>

    <v-layout v-if="!value">
      <v-flex class="text-xs-center">
        <v-btn @click="showWizard = true" flat small :loading="loading" class="nx-text--level-1">
          <v-icon left>add</v-icon>
          {{ addText }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-list v-else two-line>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>{{ compositionTitle }}</v-list-tile-title>
          <v-list-tile-sub-title>
            <div class="badges">
              <nx-badge v-if="value.published" color="nx-primary--lighten-4 nx-text--level-1">
                {{ value.publishedDate | formatDate }}
              </nx-badge>
              <nx-badge v-else color="nx-primary--lighten-4 nx-text--level-1">
                {{ value.modificationDate | formatDate }}
              </nx-badge>
              <nx-badge v-if="value.published">{{ $t('message.content.status.published') }}
              </nx-badge>
              <nx-badge v-else>{{ $t('message.content.status.draft') }}</nx-badge>
            </div>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-layout row align-center ml-4>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :to="entityEditorRoute.get('composition', value)"
                  class="nx-text--level-1 mr-2"
                  icon
                  target="_blank"
                  v-on="on">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('message.common.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="deleteComposition(value.id)"
                  :loading="loading"
                  class="nx-text--level-1"
                  icon
                  v-if="deletable"
                  v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('message.common.delete') }}</span>
            </v-tooltip>
          </v-layout>
        </v-list-tile-action>

      </v-list-tile>
    </v-list>

    <nx-fullscreen-dialog
      :active="showWizard"
      :title="$t('message.wizard.new.module')"
      dismissable
      @dismiss="showWizard = false"
    >

      <template slot="toolbar-items">
        <v-btn
          :disabled="!newCompositionName"
          @click.native="handleCreate"
          color="accent"
          :loading="loading"
          flat dark
        >Crear
        </v-btn>
      </template>

      <v-container class="px-0 pt-5 pb-0 fluid">
        <v-layout wrap>
          <v-flex class="md8 offset-md2 mb-3">
            <v-text-field
              :label="$t('message.form.fields.name')"
              v-model="newCompositionName"
              @keyup.enter="handleCreate"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </nx-fullscreen-dialog>

  </div>
</template>

<script>
import NxBadge from '@/components/Badge';
import NxRelationEditorToolbar from '@/modules/relation/editor/components/Toolbar';
import NxFullscreenDialog from '@/components/dialogs/FullscreenDialog';
import { entityEditorRoute } from '@/modules/entity/router';
import HasEntityFields from '@/modules/form/mixins/has-entity-fields';
import api from './api';

export default {
  mixins: [HasEntityFields],
  components: {
    NxBadge,
    NxRelationEditorToolbar,
    NxFullscreenDialog,
  },
  props: {
    deletable: {
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      showWizard: false,
      newCompositionName: '',
    };
  },
  computed: {
    addText() {
      return this.$t('message.wizard.new.addModule');
    },
    compositionTitle() {
      if (this.value) {
        return this.value.alias || this.value.name || this.value.title || 'Módulo';
      }
      return 'Módulo';
    },
    entityEditorRoute() {
      return entityEditorRoute;
    },
  },
  methods: {
    async deleteComposition() {
      this.$emit('input', null);
    },
    async handleCreate() {
      this.loading = true;
      try {
        const value = await api.createComposition({
          entity: this.entity,
          entityField: this.entityField,
          entityId: this.getEntityId(),
          type: this.type,
          name: this.newCompositionName,
        });
        if (value) {
          this.$emit('input', value);
        }
        this.newCompositionName = '';
        this.showWizard = false;
      } catch (e) {
        console.log('Error creating module');
      }
      this.loading = false;
    },
  },
};
</script>
